/* TespitPro Soft — small, dependency-free behaviours */
(function () {
  'use strict';

  /* Announcement rotation */
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var items = bar.querySelectorAll('.announcement__item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  });

  /* Close menu drawer on overlay click / Escape */
  document.querySelectorAll('[data-menu-drawer]').forEach(function (drawer) {
    var overlay = drawer.querySelector('.menu-drawer__overlay');
    var close = drawer.querySelector('[data-menu-close]');
    function shut() { drawer.removeAttribute('open'); }
    if (overlay) overlay.addEventListener('click', shut);
    if (close) close.addEventListener('click', shut);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') shut(); });
  });

  /* Product gallery: dots + thumbs follow the scroll position */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('.gallery__track');
    var slides = gallery.querySelectorAll('.gallery__slide');
    var controls = gallery.querySelectorAll('[data-go-to]');
    if (!track || !slides.length) return;
    function setCurrent(index) {
      controls.forEach(function (c) {
        c.setAttribute('aria-current', Number(c.dataset.goTo) === index ? 'true' : 'false');
      });
    }
    controls.forEach(function (c) {
      c.addEventListener('click', function () {
        var index = Number(c.dataset.goTo);
        track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        setCurrent(index);
      });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        setCurrent(Math.max(0, Math.min(slides.length - 1, index)));
        ticking = false;
      });
    }, { passive: true });
  });

  /* Quantity steppers */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = Number(btn.dataset.qtyStep);
        var min = Number(input.min || 0);
        var next = Math.max(min, (Number(input.value) || 0) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* Cart page: submit on quantity change */
  document.querySelectorAll('[data-cart-form]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[name="updates[]"]')) form.submit();
    });
  });

  /* Variant radios -> hidden id + price */
  document.querySelectorAll('[data-product-form-root]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-price-current]');
    var compareEl = root.querySelector('[data-price-compare]');
    var button = root.querySelector('[data-add-button]');
    var buttonLabel = button ? button.querySelector('[data-add-label]') : null;
    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-index]')) return;
      var selected = Array.prototype.map.call(root.querySelectorAll('[data-option-index]:checked'), function (el) { return el.value; });
      var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); });
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price_formatted;
      if (compareEl) {
        compareEl.textContent = match.compare_formatted || '';
        compareEl.hidden = !match.compare_formatted;
      }
      if (button) {
        button.disabled = !match.available;
        if (buttonLabel) buttonLabel.textContent = match.available ? buttonLabel.dataset.available : buttonLabel.dataset.soldout;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    });
  });

  /* Sticky buy bar: visible while the main buy box is off-screen */
  var sticky = document.querySelector('[data-sticky-buy]');
  var target = document.querySelector('[data-buy-anchor]');
  if (sticky && target && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var below = entry.boundingClientRect.top > 0;
        sticky.classList.toggle('is-visible', !entry.isIntersecting && !below);
      });
    }, { threshold: 0 });
    io.observe(target);
    var stickyButton = sticky.querySelector('[data-sticky-go]');
    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        var cod = document.querySelector('.es-popup-button');
        if (cod) { cod.click(); return; }
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  /* Estimated delivery dates (business days, skips weekends) */
  document.querySelectorAll('[data-delivery]').forEach(function (el) {
    var minDays = Number(el.dataset.min || 2);
    var maxDays = Number(el.dataset.max || 4);
    var cutoff = Number(el.dataset.cutoff || 14);
    var strings = window.themeStrings || { months: [], days: [] };
    function addBusinessDays(date, days) {
      var d = new Date(date);
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        var wd = d.getDay();
        if (wd !== 0 && wd !== 6) added++;
      }
      return d;
    }
    var now = new Date();
    var start = new Date(now);
    if (now.getHours() >= cutoff || now.getDay() === 0 || now.getDay() === 6) {
      start = addBusinessDays(now, 1);
    }
    var from = addBusinessDays(start, minDays);
    var to = addBusinessDays(start, maxDays);
    function fmt(d) { return d.getDate() + ' ' + (strings.months[d.getMonth()] || ''); }
    var out = el.querySelector('[data-delivery-range]');
    if (out) out.textContent = fmt(from) + ' – ' + fmt(to);
    var ship = el.querySelector('[data-delivery-ship]');
    if (ship) {
      var sameDay = now.getHours() < cutoff && now.getDay() !== 0 && now.getDay() !== 6;
      ship.textContent = sameDay ? ship.dataset.today : ship.dataset.next;
    }
  });

  /* Same-day shipping countdown (weekdays, until the cutoff hour) */
  document.querySelectorAll('[data-ship-countdown]').forEach(function (el) {
    var cutoff = Number(el.dataset.cutoff || 16);
    var out = el.querySelector('[data-ship-left]');
    function tick() {
      var now = new Date();
      var wd = now.getDay();
      var end = new Date(now); end.setHours(cutoff, 0, 0, 0);
      var ms = end - now;
      if (wd === 0 || wd === 6 || ms <= 0) { el.hidden = true; return false; }
      var h = Math.floor(ms / 3600000);
      var m = Math.floor((ms % 3600000) / 60000);
      var s = Math.floor((ms % 60000) / 1000);
      out.textContent = (h > 0 ? h + ' sa ' : '') + m + ' dk' + (h === 0 ? ' ' + s + ' sn' : '');
      el.hidden = false;
      return true;
    }
    if (tick()) {
      var timer = setInterval(function () { if (!tick()) clearInterval(timer); }, 1000);
    }
  });

  /* Campaign end date: show days left */
  document.querySelectorAll('[data-campaign-end]').forEach(function (el) {
    var out = el.querySelector('[data-campaign-left]');
    var parts = (el.dataset.campaignEnd || '').split('-').map(Number);
    if (!out || parts.length !== 3 || parts.some(isNaN)) return;
    var end = new Date(parts[0], parts[1] - 1, parts[2], 23, 59, 59);
    var days = Math.ceil((end - new Date()) / 86400000);
    if (days < 0) { el.hidden = true; return; }
    out.textContent = days <= 1 ? ' · Son gün!' : ' · Son ' + days + ' gün';
  });

  /* Horizontal scrollers with prev/next buttons */
  document.querySelectorAll('[data-scroller]').forEach(function (wrap) {
    var row = wrap.querySelector('[data-scroller-row]');
    if (!row) return;
    wrap.querySelectorAll('[data-scroll-dir]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = Number(btn.dataset.scrollDir);
        row.scrollBy({ left: dir * row.clientWidth * 0.85, behavior: 'smooth' });
      });
    });
  });

  /* Videos: play one at a time */
  var videos = document.querySelectorAll('[data-video-card] video');
  videos.forEach(function (v) {
    v.addEventListener('play', function () {
      videos.forEach(function (other) { if (other !== v) other.pause(); });
    });
  });
})();
